import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import ApolloQuery from '../../modules/react/components/stateful/ApolloQuery';
import CurrentBuilderPageContext, { getDefaultValue } from '../contexts/CurrentBuilderPageContext';
import BuilderPagesDropdown from '../components/BuilderPagesDropdown';
import ViewLiveButton from '../components/ViewLiveButton';

const GET_DATA = gql`
  query GetBuilderPageProviderData($id: ID!) {
    page(id: $id) {
      id
      ...BuilderPagesDropdownCurrentPage
      ...ViewLiveButtonCurrentPage
    }
  }

  ${BuilderPagesDropdown.fragments.contexts.currentPage}
  ${ViewLiveButton.fragments.contexts.currentPage}
`;

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  id: PropTypes.string.isRequired,
};

const defaultProps = {};

const BuilderPageProvider = ({
  children,
  id,
}) => (
  <ApolloQuery
    advanced
    query={GET_DATA}
    variables={{ id }}
  >
    {({ data, error, loading }) => {
      let value = getDefaultValue();
      value = {
        ...value,
        isBuilderView: true,
      };

      if (data) {
        const { page } = data;

        value = {
          ...page,
          ...value,
          loading: false,
          loaded: true,
        };
      }

      if (error) {
        // TODO: Show a nice pretty error screen instead of an ugly white screen.
      }

      if (loading) {
        value = {
          ...value,
          loading: true,
          loaded: false,
        };
      }

      return (
        <CurrentBuilderPageContext.Provider value={value}>
          {children}
        </CurrentBuilderPageContext.Provider>
      );
    }}
  </ApolloQuery>
);

BuilderPageProvider.propTypes = propTypes;
BuilderPageProvider.defaultProps = defaultProps;

export default BuilderPageProvider;
